import { IWorkbenchConfig } from './typings';

const config: IWorkbenchConfig = {
  isShowOverview: false,
  cutoverControllerId: 'cutover',
  settingControllerId: 'openSetting',
};

export default config;
